<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hDqI6c/tc-custom/9781439665145.jpg?1702530412166" alt="This image is the cover for the book Haunted Florence, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Florence, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p>Florence occupies a huge space in American history, and that past left a lot of lingering spirits. A Native American "trickster" meanders the local swamps. In Mars Bluff, a ghostly guide offers tours of a beloved plantation. A dedicated worker in the former Jamestown area still haunts a dilapidated tobacco barn. At an abandoned boardinghouse, a spectral couple searches for a lost trinket. Author H.P. Bradley details these stories and more of the historic hauntings in the Magic City.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H.P. Bradley
      </h2>
      
      <p class="authorDescription body article">Heather lives in Florence with her young son, Daniel. She has her own website to communicate and connect with her (https://hpbradley.wixsite.com/hp-bradley). Heather is also currently developing her own curricula for a K-12 academic education program that includes the components of 1.1 tutoring, online learning, intriguing books of every kind and community-based experiential learning.<br><br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b36ff02